<template>
  <div :class="$style.topbar">
    <div class="mr-4">
      <cui-fav-pages />
    </div>
    <!-- <div class="mr-auto">
      <cui-search />
    </div> -->
    <div class="mr-4 d-none d-sm-block ml-auto">
      <cui-language-switcher />
    </div>
    <!-- <div class="mr-4 d-none d-sm-block">
      <cui-actions />
    </div> -->
    <div class="mr-4">
      <my-store />
    </div>
    <div class="ml-auto ml-sm-0">
      <cui-user-menu />
    </div>
  </div>
</template>

<script>
// import CuiSearch from './Search'
import CuiLanguageSwitcher from './LanguageSwitcher'
// import CuiActions from './Actions'
import CuiUserMenu from './UserMenu'
import CuiFavPages from './FavPages'
import MyStore from './MyStore'

export default {
  components: {
    // CuiSearch,
    CuiLanguageSwitcher,
    // CuiActions,
    CuiUserMenu,
    CuiFavPages,
    MyStore,
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
